/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {SignalAdminResourcePage} from '../common/controller/signal-admin-resource-api';
import {PoliticalCampaignModel} from './political-campaign-api.service';

@Injectable({providedIn: 'root'})
export class PublicPoliticalCampaignApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(id: string): Observable<PoliticalCampaignModel> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['public', 'politicalcampaigns', id])
    });
  }

  grouped(params: Record<string, any>): Observable<SignalAdminResourcePage<any>> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['public', 'politicalcampaigns', 'grouped']),
      params
    });
  }
}
